module.exports = __webpack_public_path__ + "static/img/img-user1.4410606.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare_new/img-user1.jpg
// module id = P5qH
// module chunks = 1